import React, { useEffect } from "react";
import { FormControlLabel } from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { InputAdornment } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    padding: theme.spacing(5),
  },
}));

function AadhaarInput({ handleOtp, getAadhaarId }) {
  const classes = useStyles();
  const [showAadhaar, setShowAadhaar] = React.useState(false);
  const [selectedConsentApproval1, setConsentApproval1] = React.useState(false);
  const [selectedConsentApproval2, setConsentApproval2] = React.useState(false);
  const [selectedConsentApproval3, setConsentApproval3] = React.useState(false);
  const [selectedConsentApproval4, setConsentApproval4] = React.useState(false);
  const [selectedConsentApproval5, setConsentApproval5] = React.useState(false);
  const [selectedConsentApproval6, setConsentApproval6] = React.useState(false);
  const [benificieryName, setBenificieryName] = React.useState("");
  const [healtCareWorkerName, setHealthCareWorkerName] = React.useState("");
  const [selectedConsentApproval7, setConsentApproval7] = React.useState(false);
  const [aadhaarId, setAadhaarId] = React.useState("");

  useEffect(() => {
    if (global.benificiaryName !== "" || global.benificiaryName !== null)
      setBenificieryName(global.benificiaryName);
    if (global.user !== null || global.user !== "")
      setHealthCareWorkerName(global.user);
    if (global.aadharNumber !== null || global.aadharNumber !== "") {
      setAadhaarId(global.aadharNumber);
    }
  }, []);

  const handleAadhaarId = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAadhaarId(value);
    } else {
      setAadhaarId((prevValue) => prevValue); // Clear the input if it doesn't match the regex
    }
  };

  const getOtp = () => {
    handleOtp(aadhaarId);
    getAadhaarId(aadhaarId);
  };

  const handleAcknowledgeAll = () => {
    setConsentApproval1(true);
    setConsentApproval2(true);
    setConsentApproval3(true);
    setConsentApproval4(true);
    setConsentApproval5(true);
    setConsentApproval7(true);
  };

  const handleShowAadhaar = () => {
    setShowAadhaar(!showAadhaar);
  };

  const checkBoxApproval1 = () => {
    setConsentApproval1(!selectedConsentApproval1);
  };
  const checkBoxApproval2 = () => {
    setConsentApproval2(!selectedConsentApproval2);
  };
  const checkBoxApproval3 = () => {
    setConsentApproval3(!selectedConsentApproval3);
  };
  const checkBoxApproval4 = () => {
    setConsentApproval4(!selectedConsentApproval4);
  };
  const checkBoxApproval5 = () => {
    setConsentApproval5(!selectedConsentApproval5);
    // setConsentApproval6(!selectedConsentApproval6);
    setConsentApproval7(!selectedConsentApproval7);
  };
  const checkBoxApproval6 = () => {
    setConsentApproval6(!selectedConsentApproval6);
  };
  return (
    <form className={classes.form} noValidate style={{ overflow: "hidden" }}>
      <Grid
        container
        direction={"row"}
        st
        spacing={5}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item>
          <TextField
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowAadhaar} edge="end">
                    {showAadhaar ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={aadhaarId}
            autoFocus
            id="aadhaarId"
            label="Aadhaar Number"
            required
            variant="standard"
            type={showAadhaar ? "text" : "password"}
            style={{ marginTop: -5 }}
            onChange={(e) => handleAadhaarId(e.target.value)}
            inputProps={{ maxLength: 12 }}
          />
        </Grid>
        <Grid item>
          {global.user == "" ? (
            <Button
              type="button"
              fullWidth
              variant="contained"
              style={{
                backgroundColor:
                  selectedConsentApproval1 &&
                  selectedConsentApproval2 &&
                  selectedConsentApproval3 &&
                  selectedConsentApproval4 &&
                  selectedConsentApproval5 &&
                  selectedConsentApproval7 &&
                  benificieryName.trim() != ""
                    ? global.secondaryColour
                    : "#ccc",
                color: "#fff",
                paddingBottom: 10,
              }}
              className={classes.submit}
              onClick={() => handleOtp(aadhaarId)}
              disabled={
                selectedConsentApproval1 &&
                selectedConsentApproval2 &&
                selectedConsentApproval3 &&
                selectedConsentApproval4 &&
                selectedConsentApproval5 &&
                selectedConsentApproval7 &&
                benificieryName.trim() != ""
                  ? false
                  : true
              }
            >
              Get OTP
            </Button>
          ) : (
            <Button
              type="button"
              fullWidth
              variant="contained"
              style={{
                backgroundColor:
                  selectedConsentApproval1 &&
                  selectedConsentApproval2 &&
                  selectedConsentApproval3 &&
                  selectedConsentApproval4 &&
                  selectedConsentApproval5 &&
                  selectedConsentApproval7 &&
                  benificieryName.trim() != ""
                    ? global.secondaryColour
                    : "#ccc",
                color: "#fff",
                paddingBottom: 10,
              }}
              className={classes.submit}
              onClick={() => getOtp()}
              disabled={
                selectedConsentApproval1 &&
                selectedConsentApproval2 &&
                selectedConsentApproval3 &&
                selectedConsentApproval4 &&
                selectedConsentApproval5 &&
                selectedConsentApproval7 &&
                benificieryName.trim() != ""
                  ? false
                  : true
              }
            >
              Get OTP
            </Button>
          )}
        </Grid>
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span style={{ fontSize: "0.7rem" }}>I hereby declare that:</span>
        <Button
          variant="default"
          style={{ color: "#f53169d9" }}
          onClick={() => handleAcknowledgeAll()}
        >
          Accept All
        </Button>
      </div>

      <div id="consent_div" style={{ marginTop: 10 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedConsentApproval1 ? true : false}
              onChange={() => {
                checkBoxApproval1();
              }}
              name="selectedConsentApproval1"
            />
          }
          label={
            <p
              style={{
                fontSize: "0.7rem",
              }}
            >
              I am voluntarily sharing my Aadhaar Number / Virtual ID issued by
              the Unique Identification Authority of India (“
              <strong>UIDAI</strong>”), and my demographic information for the
              purpose of creating an Ayushman Bharat Health Account number (“
              <strong>ABHA number</strong>”) and Ayushman Bharat Health Account
              address (“<strong>ABHA Address</strong>”). I authorize NHA to use
              my Aadhaar number / Virtual ID for performing Aadhaar based
              authentication with UIDAI as per the provisions of the Aadhaar
              (Targeted Delivery of Financial and other Subsidies, Benefits and
              Services) Act, 2016 for the aforesaid purpose. I understand that
              UIDAI will share my e-KYC details, or response of “Yes” with NHA
              upon successful authentication.
            </p>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={selectedConsentApproval2 ? true : false}
              onChange={() => {
                checkBoxApproval2();
              }}
              name="selectedConsentApproval2"
            />
          }
          label={
            <p style={{ fontSize: "0.7rem" }}>
              I intend to create Ayushman Bharat Health Account Number (“
              <strong>ABHA number</strong>”) and Ayushman Bharat Health Account
              address (“<strong>ABHA Address</strong>”) using document other
              than Aadhaar.
            </p>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={selectedConsentApproval3 ? true : false}
              onChange={() => {
                checkBoxApproval3();
              }}
              name="selectedConsentApproval3"
            />
          }
          label={
            <p style={{ fontSize: "0.7rem" }}>
              I consent to usage of my ABHA address and ABHA number for linking
              of my legacy (past) health records and those which will be
              generated during this encounter.
            </p>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={selectedConsentApproval4 ? true : false}
              onChange={() => {
                checkBoxApproval4();
              }}
              name="selectedConsentApproval4"
            />
          }
          label={
            <p style={{ fontSize: "0.7rem" }}>
              I authorize the sharing of all my health records with healthcare
              provider(s) for the purpose of providing healthcare services to me
              during this encounter.
            </p>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={selectedConsentApproval5 ? true : false}
              onChange={() => {
                checkBoxApproval5();
              }}
              name="selectedConsentApproval5"
            />
          }
          label={
            <p style={{ fontSize: "0.7rem" }}>
              I consent to the anonymization and subsequent use of my health
              records for public health purposes.
            </p>
          }
        />

        {global.user == "" ? (
          <FormControlLabel
            style={{ marginLeft: 20 }}
            control={
              <Checkbox
                checked={selectedConsentApproval6 ? true : false}
                onChange={() => {
                  checkBoxApproval6();
                }}
                name="selectedConsentApproval6"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I,{" "}
                <TextField
                  placeholder="healthcare worker name"
                  onChange={(e) => setHealthCareWorkerName(e.target.value)}
                  value={healtCareWorkerName}
                />
                , confirm that I have duly informed and explained the
                beneficiary of the contents of consent for aforementioned
                purposes.
              </p>
            }
          />
        ) : (
          <FormControlLabel
            style={{ marginLeft: 20 }}
            control={
              <Checkbox
                checked={selectedConsentApproval6 ? true : false}
                onChange={() => {
                  checkBoxApproval6();
                }}
                name="selectedConsentApproval6"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I,{" "}
                <TextField
                  placeholder="healthcare worker name"
                  disabled={true}
                  value={healtCareWorkerName}
                />
                , confirm that I have duly informed and explained the
                beneficiary of the contents of consent for aforementioned
                purposes.
              </p>
            }
          />
        )}

        {global.benificiaryName === "" ? (
          <FormControlLabel
            style={{ marginLeft: 20 }}
            control={
              <Checkbox
                checked={selectedConsentApproval7 ? true : false}
                // onChange={() => {
                //   checkBoxApproval7();
                // }}
                name="selectedConsentApproval7"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I,{" "}
                <TextField
                  placeholder="beneficiary name"
                  onChange={(e) => setBenificieryName(e.target.value)}
                  value={benificieryName}
                />
                , have been explained about the consent as stated above and
                hereby provide my consent for the aforementioned purposes.
              </p>
            }
          />
        ) : (
          <FormControlLabel
            style={{ marginLeft: 20 }}
            control={
              <Checkbox
                checked={selectedConsentApproval5 ? true : false}
                // onChange={() => {
                //   checkBoxApproval7();
                // }}
                name="selectedConsentApproval7"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I,{" "}
                <TextField
                  placeholder="beneficiary name"
                  value={benificieryName}
                  disabled={true}
                />
                , have been explained about the consent as stated above and
                hereby provide my consent for the aforementioned purposes.
              </p>
            }
          />
        )}
      </div>
    </form>
  );
}

export default AadhaarInput;
